import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const IOT = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>The Internet of Things: An Overview of what is IoT? Why IoT? Explain the definition and usage of the term "Internet of Things (IoT)" in different contexts. Design Principles for Connected Devices, internet principles: internet communications-An overview, Physical Design of IoT, Logical Design of IoT, IoT standards, IoT generic architecture and IoT protocols. IoT future trends, Understand IoT Applications and Examples. Understand various IoT architectures based on applications. Understand different classes of sensors and actuators. Sensors: sensor terminology, sensor dynamics and specifications. Understand the basics of hardware design needed to build useful circuits using basic sensors and actuators.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Communication protocols and Arduino Programming: Understand various network protocols used in IoT, Understand various communication protocols (SPI, I2C, UART). Design and develop Arduino code needed to communicate the microcontroller with sensors and actuators, build circuits using IoT supported Hardware platforms such as Arduino, ESP8266 etc., Use of software libraries with an Arduino sketch that allows a programmer to use complicated hardware without dealing with complexity, Learning IoT application programming and build solutions for real life problems and test them in Arduino and Node MCU environments. Understand various wireless Technologies for IoT and its range, frequency and applications.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Fundamentals of IEEE 802.15.4, Zigbee and 6LOWPAN: Importance of IEEE 802.15.4 MAC and IEEE 802.15.4 PHY layer in constrained networks and their header format, Importance of Zigbee technology and its applications, use of IPv6 in IoT Environments, Understanding importance of IPv6 and how constrained nodes deal with bigger headers (IPv6). Understand IPv6 over Low-Power WPAN (6LoWPAN) and role of 6LoWPAN in wireless sensor network. Various routing techniques in constrained network. Understanding IoT Application Layer Protocols: HTTP, CoAP Message Queuing Telemetry Transport (MQTT).</p>
    </div>,
    <div key="4" className="p-4">
      <p>Application areas and Real-time Case Studies: Role of big data, cloud computing and data analytics in a typical IoT system. Analyze various case studies implementing IoT in real world environment and find out the solutions of various deployment issues. Smart parking system, Smart irrigation system-block diagram, sensors, modules on Arduino and Node MCU.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Introduction to Internet of Things"
      subjectKey="iot"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'IOTNotes',
        videos: 'IOTVideos'
      }}
    />
  );
};

export default IOT;